import React from "react";
import { isArray } from "lodash";
import { _getBaseUrl, _getTranslation } from "../utils/helper";

const CardLibrary = ({ data, nodeType, ...props }) => {
  let day, month;

  const alias = props?.alias || window.location.pathname;

  // console.log("data", data);

  if (data.datum && data.datum !== "") {
    const parts = data.datum.split("<br>");
    day = parts[0].trim();
    month = parts[1].trim();
  }

  return (
    <div className="library-card">
      <div class="h-full w-full">
        <a
          href={data.permalink}
          class="hover:no-underline hover:opacity-40 h-full w-full flex items-center md:block gap-5"
        >
          <div class="w-2/5 md:w-full relative">

            {Array.isArray(data.actueel_type) && data.actueel_type.includes("Publicaties") ? (
              <div className="relative">
                {data.imageUrl ? (
                  <>
                    <div
                      className="w-full aspect-[12/4] md:rounded-[20px] rounded-[6px] top-1/2 absolute -translate-y-1/2"
                      style={{ backgroundColor: data.imageColour }}
                    ></div>
                    <div class="-translate-x-1/2 ml-[50%] border border-[rgba(0,0,0,0.2)] w-[34%] rounded-[10px]">
                      <img
                        src={data.imageUrl}
                        alt={data.imageAlt}
                        class="rounded-[10px]"
                      />
                    </div>
                  </>
                ) : (
                  <div className="w-full h-full bg-cirGreyBox md:rounded-[20px] rounded-[6px]"></div>
                )}
              </div>
            ) : (
              <div>
                {data.imageUrl ? (
                  <img
                    src={data.imageUrl}
                    alt={data.imageAlt}
                    className="md:rounded-[20px] rounded-[6px]"
                  />
                ) : null}
              </div>
            )}

            {data.status && data.status.length > 0 && (
              <span
                class="text-sm scale-text-150:text-lg scale-text-200:text-[22px] absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-full border text-white bg-black border-black
            flex items-center justify-center"
              >
                {data.status}
              </span>
            )}
            {data.datum && data.datum !== "" && (
              <span
                className={`text-center font-sharpgrotesk absolute top-3 left-3 w-auto mb-4 py-1 px-4 rounded-[16px] border text-white ${alias === "/de-her/agenda"
                  ? "bg-cirDeHerGreen border-cirDeHerGreen"
                  : "bg-black border-black"
                  }  flex flex-col items-center justify-center`}
              >
                <span className="text-sm lg:text-xl scale-text-150:text-2xl scale-text-200:text-3xl">
                  {day}
                </span>
                <span className="text-xs lg:text-base scale-text-150:text-lg scale-text-200:text-xl">
                  {month}
                </span>
              </span>
            )}
          </div>
          <div class="w-3/5 md:w-full">
            {nodeType === "agenda" ? (
              <h3 className="h4 font-normal font-franklin text-cirBlack pt-1 flex flex-col-reverse md:pt-5">
                {data.title}
                {data.date !== "" && (
                  <span className="h6 pb-1 md:pb-2">{data.date}</span>
                )}
                {data.location && data.location !== "" && (
                  <div className="location-button text-cirGrey text-sm pb-1 md:pb-2 flex items-start gap-4">
                    <span className="pt-0.5">{data.location}</span>
                  </div>
                )}
              </h3>
            ) : nodeType === "actueel" ? (
              <h2 className="h4 font-normal font-franklin text-cirBlack pt-1 flex flex-col-reverse md:pt-5">
                {data.title}
                {data.date !== "" && (
                  <span className="h6 pb-1 md:pb-2">{data.date}</span>
                )}
                {data.location && data.location !== "" && (
                  <div className="location-button text-cirGrey text-sm pb-1 md:pb-2 flex items-start gap-4">
                    <span className="pt-0.5">{data.location}</span>
                  </div>
                )}
              </h2>
            ) : null}

            {(
              (Array.isArray(data.actueel_type) && data.actueel_type.length > 0) ||
              (Array.isArray(data.actueel_wijken) && data.actueel_wijken.length > 0)
            ) && (
                <div className="flex items-center md:my-4 post-listing-dot">
                  {Array.isArray(data.actueel_type) && data.actueel_type.length > 0 && (
                    <span className="h6 tracking-[0.7px]">
                      {data.actueel_type.join(" · ")}
                    </span>
                  )}
                  {Array.isArray(data.actueel_wijken) && data.actueel_wijken.length > 0 && (
                    <span className="h6 tracking-[0.7px]">
                      {data.actueel_wijken.join(" · ")}
                    </span>
                  )}
                </div>
              )}
          </div>
        </a>
      </div>
    </div>
  );
};

export default CardLibrary;
